import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import { useLocation } from "react-router-dom";
import { MdDeleteOutline } from "react-icons/md";
import { addHolidayAPI, getHolidaysAPI, deleteHolidayAPI } from '../../serverApi/server'


const HolidayManagement = () => {
    const location = useLocation();
    const [holidayDetails, setHolidayDetails] = useState([]);
    const toggleMailForm = () => setMailSendOpenForm(!mailSendOpenForm);
    const [mailSendOpenForm, setMailSendOpenForm] = useState(false);
    const [holidayDate, setHolidayDate] = useState('');
    const [holidayName, setHolidayName] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getHolidayAPIDetailsAPIResponse();
    }, [])

    const getHolidayAPIDetailsAPIResponse = async () => {
        try {
            const getgetHolidaysAPIDetailsResponse = await getHolidaysAPI();
            setHolidayDetails(getgetHolidaysAPIDetailsResponse.data.holiday_details)
        } catch (error) {
            console.error(error);
        }
    }

    const addHoliday = async (e) => {
        toggleMailForm();
        e.preventDefault(); 
        const HolidayAPIResponse = await addHolidayAPI(holidayDate, holidayName);
        if (HolidayAPIResponse.data.client_status_code === 201) {
            setHolidayDate('');
            setHolidayName('');
            await getHolidayAPIDetailsAPIResponse()
        }
    }

    const deleteHolidayDate = async (id) => {
        setLoading(true)
        await deleteHolidayAPI(id)
        getHolidayAPIDetailsAPIResponse();
        setTimeout(()=>{
            setLoading(false)
        }, 2000)
    }

    return (
        <div className="flex w-full h-screen">
            <div className="fixed h-full custom-scroll">
                <SideBar />
            </div>
            <div className="ml-64 flex-1 overflow-y-auto">
                <Header />
                <div className="bg-[#F5F7FD] px-7 py-6">
                    <div className="flex items-center justify-between">
                        <div className="text-blue-950 flex items-center gap-6">
                            <h1 className="pr-6 text-2xl font-medium border-r">
                                Admin User
                            </h1>
                            <div className="flex text-sm items-center gap-3">
                                <button>
                                    <SlHome />
                                </button>
                                <SlArrowRight />
                                <button>Holiday Management</button>
                            </div>
                        </div>
                        <div>
                            <button
                                className="bg-blue-500 hover:bg-blue-400 duration-200 px-4 py-2 rounded text-white mr-4 md:mr-8"
                                onClick={toggleMailForm}
                            >
                                Add Holiday Date
                            </button>
                            {/* <button
                                className="bg-blue-500 hover:bg-blue-400 duration-200 px-4 py-2 rounded text-white mr-4 md:mr-8"
                                onClick={toggleForm}
                            >
                                Add Mail
                            </button> */}
                        </div>
                    </div>

                    {mailSendOpenForm && (
                        <div
                            className="overflow-y-auto fixed inset-0 h-full z-50 flex items-center justify-center bg-black bg-opacity-50"
                        >
                            <div className="bg-white rounded-lg w-11/12 max-w-md max-h-[90vh] overflow-y-auto">
                                <div className="flex justify-between items-center p-4 border-b">
                                    <h5 className="text-lg font-medium">
                                        Add Holiday Date
                                    </h5>
                                    <button
                                        type="button"
                                        className="text-gray-600 text-3xl hover:text-gray-900"
                                        onClick={toggleMailForm}
                                    >
                                        &times;
                                    </button>
                                </div>
                                <div className="p-4">
                                    <form onSubmit={addHoliday}>
                                        <div className="mb-4">
                                            <label
                                                htmlFor="category_zip_file"
                                                className="block text-sm text-gray-700"
                                            >
                                                Enter The Holiday Name:
                                            </label>
                                            <input
                                                type='text'
                                                name="holidayName"
                                                required
                                                onChange={(e) => { setHolidayName(e.target.value); }}
                                                placeholder="Enter The Holiday Name"
                                                className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                                            />
                                        </div>
                                        
                                        <div className="mb-4">
                                            <label
                                                htmlFor="category_zip_file"
                                                className="block text-sm text-gray-700"
                                            >
                                                Select The Holidate:
                                            </label>
                                            <input
                                                type="date"
                                                name="expiry_date"
                                                required
                                                onChange={(e) => setHolidayDate(e.target.value)}
                                                placeholder="Select expiry date"
                                                className="mt-2 block w-full rounded-md border-2 px-3 py-2 focus:outline-none shadow-sm"
                                            />
                                        </div>
                                        <div className="flex justify-end items-center p-4 border-t">
                                            <button
                                                type="submit"
                                                className="bg-blue-500 hover:bg-blue-400 duration-200 px-3 py-2 text-white rounded"
                                            >
                                                Submit
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="bg-white mt-10 px-3 py-4 rounded-lg">
                        <div className="overflow-x-auto table-auto">
                            <table className="min-w-full bg-white mt-8" style={{ borderCollapse: 'separate', borderSpacing: '2px' }}>
                                <thead>
                                    <tr>
                                        <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">HOLIDAY NAME</th>
                                        <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">HOLIDAY DATE</th>
                                        <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {holidayDetails && holidayDetails.length > 0 ? (
                                        holidayDetails.map((holidayDetail) => (
                                            <tr key={holidayDetail.id}>
                                                <td className="px-4 py-2 font-normal border border-[#48ABF7] capitalize">{holidayDetail.holiday_name}</td>
                                                <td className="px-4 py-2 font-normal border border-[#48ABF7]">{holidayDetail.holiday_date}</td>
                                                <td className="px-4 py-2 border border-[#48ABF7]" style={{display: 'flex', height: '60px'}}>
                                                    {/* <button 
                                                        className="bg-blue-500 text-white py-1 px-3 rounded-full flex items-center"
                                                        style={{marginRight: '10px'}}
                                                        onClick={() => editClientMailDetails(clientMail.id)}
                                                    >
                                                    <FaEdit className="mr-[1px]"/>
                                                    UPDATE
                                                    </button> */}

                                                    <button 
                                                        className="bg-red-500 text-white py-1 px-3 rounded-full flex items-center" 
                                                        onClick={() => deleteHolidayDate(holidayDetail.id)}
                                                    >
                                                    <MdDeleteOutline className="mr-[1px]"/>
                                                    DELETE
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="px-4 py-2 text-center font-normal border border-[#48ABF7]">
                                                    Holiday details are not available
                                                </td>
                                            </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        {loading && (
                            <div className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-90 flex flex-col justify-center items-center z-50">
                                <div className="w-12 h-12 border-4 border-gray-300 border-t-4 border-t-orange-500 rounded-full animate-spin"></div>
                                <p className="mt-4 text-sm sm:text-base md:text-lg text-gray-600">
                                    Loading, please wait...
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HolidayManagement;
